document.addEventListener('DOMContentLoaded', function() {
    const navItems = document.querySelectorAll('.latest-nav .clickable');
    const contentSections = document.querySelectorAll('.latest-content .content-section');

    navItems.forEach(item => {
        item.addEventListener('click', function() {
            const target = this.getAttribute('data-target');

            navItems.forEach(nav => nav.classList.remove('active'));
            this.classList.add('active');

            contentSections.forEach(section => {
                // add hidden class from all sections
                section.classList.add('hidden');
                // remove hidden class from the section with the matching target
                if (section.getAttribute('data-target') === target) {
                    section.classList.remove('hidden');
                }
            });
        });
    });
});
